<template>
  <div>
      <div class="page-header">
          <img src="../assets/联系我们.webp"/>
          <div class="page-header-content" style="color: white;">
              <div style="font-weight: 500;font-size: 48px;font-style: normal;letter-spacing: 4px;line-height: 66px;text-decoration: none;">联系我们</div>
              <!-- <div style="margin-top: 20px;max-width: 70%;line-height: 28px;">"在这里，我们始终敞开着沟通的大门，期待着与您建立更加紧密的联系。无论您是寻求教育合作的伙伴，还是渴望了解更多教育资讯的朋友，亦或是希望获得个性化学习建议的学生及家长，我们都将以最诚挚的态度，最专业的服务，回应您的每一个需求。</div> -->
          </div>
      </div>
      <div class="content">
        <div> 
          <div class="content-title">皓程蔚来科技有限公司</div>
          <div class="content-sub">
            <!-- <div>全国服务电话</div> -->
            <div>电话：18683251583</div>
            <div>邮箱：86430436@qq.com</div>
          </div>
        </div>
        <div> 
          <div class="content-title">地理位置</div>
          <div class="content-sub">
            <div >中国（四川）自由贸易试验区天府新区</div>
            <div>兴隆街集萃街619号天府海创园2-2号楼17层</div>
          </div>
        </div>

      </div>
      
     
      

  </div>
</template>
<script>
  export default {
      name: 'Index',
     
  }
</script>

<style scoped>
  
  .content {
    display: flex;
    margin: 80px 30vh 20vh;
  
  }

  .content > div {
    padding-left: 100px;
    width: 50%;
  }

  .content-title {
    font-weight: 700;
    font-size: 24px;
    color: rgb(51, 51, 51);
    font-style: normal;
    letter-spacing: 2.1px;
    line-height: 38px;
  }

  .content-sub {
    margin-top: 30px;
  }

  .content-sub > div {
    margin-top: 2px;
    font-weight: 400;
    font-size: 14px;
    color: rgb(85, 85, 85);
    font-style: normal;
    letter-spacing: 2px;
    line-height: 24px;
    text-decoration: none;
  }
</style>